import yaml from 'js-yaml';
import rulesYaml from './report-rules.yaml?raw';

// eslint-disable-next-line no-useless-assignment
let parsedRules = {};

try {
  parsedRules = yaml.load(rulesYaml) || {};
} catch (error) {
  // Fallback seguro em caso de erro de parsing
  // Mantemos objeto vazio para evitar quebra de build
  console.error('Erro ao carregar report-rules.yaml:', error);
  parsedRules = {};
}

export const reportRules = parsedRules;
